<dashboardnav>
  <!-- <pre>{{searchScholarshipManagement$ | async | json}}</pre> -->
  <!-- <pre>{{isLoadingScholarshipPayment$ | async}}</pre> -->
  <div class="reference_body">
    <main class="reference_main">
      <div class="pink_box"></div>
      <div class="green_box"></div>
  <div [ngSwitch]="task">
    <ng-template ngSwitchCase = "list">

  <mrsoftapps-scholarship-management-list

  [countries]="country$ | async"
  [states]="state$ | async"
  [lgas]="lga$ | async"
  [scholarshipTypes]="scholarshipType$ | async"
  [scholarshipCategories]="scholarshipCategory$ | async"
  [scholarshipSessions]="scholarshipSession$ | async"
  [scholarshipAwardDurations]="scholarshipAwardDuration$ | async"
  [communities]="community$ | async"
  [courseOfStudies]="courseOfStudy$ | async"
  [searchScholarshipManagement]="searchScholarshipManagement$ | async"
  [genders]="gender$ | async"
  [scholarshipManagements]="scholarshipManagement$ | async"
  [scholarshipPayments]="scholarshipPayment$ | async"
  [banks]="bank$ | async"
  (searchEmit)="onSearch($event)"
  (emitEvent)="onEmitEvent($event)"
  (dispatchEdit)="onEditEvent($event)"
  (getPaymentEmit)="getPayment($event)"
  (dispatchView)="onViewEvent($event)"
  (dispatchDelete)="onDeleteEvent($event)"
  *ngIf="
    !(isLoadingScholarshipManagement$ | async) &&
    !(isLoadingCountry$ | async) &&
    !(isLoadingState$ | async) &&
    !(isLoadingLga$ | async) &&
    !(isLoadingCommunity$ | async) &&
    !(isLoadingScholarshipType$ | async) &&
    !(isLoadingScholarshipAwardDuration$ | async) &&
    !(isLoadingCourseOfStudy$ | async) &&
    !(isLoadingScholarshipCategory$ | async) &&
    !(isLoadingScholarshipSession$ | async) &&
    !(isLoadingScholarshipPayment$ | async) &&
    !(isLoadingGender$ | async)
  "
  >

  </mrsoftapps-scholarship-management-list>

</ng-template>

<ng-template ngSwitchCase = "upload">
  <mrsoftapps-scholarship-management
    [countries]="country$ | async"
    [states]="state$ | async"
    [lgas]="lga$ | async"
    [scholarshipTypes]="scholarshipType$ | async"
    [scholarshipCategories]="scholarshipCategory$ | async"
    [scholarshipSessions]="scholarshipSession$ | async"
    [scholarshipAwardDurations]="scholarshipAwardDuration$ | async"
    [communities]="community$ | async"
    [courseOfStudies]="courseOfStudy$ | async"
    [genders]="gender$ | async"
    [scholarshipManagements]="scholarshipManagement$ | async"
    (taskEmit)="taskEmit($event)"
    (changeEmit)="uploadEmit($event)"
    *ngIf="
      !(isLoadingScholarshipManagement$ | async) &&
      !(isLoadingCountry$ | async) &&
      !(isLoadingState$ | async) &&
      !(isLoadingLga$ | async) &&
      !(isLoadingCommunity$ | async) &&
      !(isLoadingScholarshipType$ | async) &&
      !(isLoadingScholarshipAwardDuration$ | async) &&
      !(isLoadingCourseOfStudy$ | async) &&
      !(isLoadingScholarshipCategory$ | async) &&
      !(isLoadingScholarshipSession$ | async) &&
      !(isLoadingGender$ | async)
    "
  >
  </mrsoftapps-scholarship-management>
</ng-template>

<ng-template ngSwitchCase = "create">
  <mrsoftapps-create-scholarship-management

  [countries]="country$ | async"
  [states]="state$ | async"
  [lgas]="lga$ | async"
  [scholarshipTypes]="scholarshipType$ | async"
  [scholarshipCategories]="scholarshipCategory$ | async"
  [scholarshipSessions]="scholarshipSession$ | async"
  [scholarshipAwardDurations]="scholarshipAwardDuration$ | async"
  [communities]="community$ | async"
  [courseOfStudies]="courseOfStudy$ | async"
  [genders]="gender$ | async"
  [scholarshipManagements]="scholarshipManagement$ | async"
  [scholarshipData]="scholarshipData"
  (changeEmit)="createEmit($event)"
  (taskEmit)="taskEmit($event)"
  *ngIf="
    !(isLoadingScholarshipManagement$ | async) &&
    !(isLoadingCountry$ | async) &&
    !(isLoadingState$ | async) &&
    !(isLoadingLga$ | async) &&
    !(isLoadingCommunity$ | async) &&
    !(isLoadingScholarshipType$ | async) &&
    !(isLoadingScholarshipAwardDuration$ | async) &&
    !(isLoadingCourseOfStudy$ | async) &&
    !(isLoadingScholarshipCategory$ | async) &&
    !(isLoadingScholarshipSession$ | async) &&
    !(isLoadingGender$ | async)
  "
  >

  </mrsoftapps-create-scholarship-management>
</ng-template>

<ng-template ngSwitchCase = "view">
  <!-- <pre>{{scholarshipPayment$ | async | json}}</pre> -->
  <mrsoftapps-view-scholarship-management
   [countries]="country$ | async"
  [states]="state$ | async"
  [lgas]="lga$ | async"
  [scholarshipTypes]="scholarshipType$ | async"
  [scholarshipCategories]="scholarshipCategory$ | async"
  [scholarshipSessions]="scholarshipSession$ | async"
  [scholarshipAwardDurations]="scholarshipAwardDuration$ | async"
  [communities]="community$ | async"
  [courseOfStudies]="courseOfStudy$ | async"
  [genders]="gender$ | async"
  [scholarshipManagements]="scholarshipManagement$ | async"
  [scholarshipPayments]="scholarshipPayment$ | async"
  [banks]="bank$ | async"
  [bankDetails]="bankDetail$ | async"
  [currencies]="currency$ | async"
  [scholarshipData]="scholarshipData"
  (changeEmit)="createEmit($event)"
  (getPaymentEmit)="getPayment($event)"
  (getBankDetailEmit)="getBankDetail($event)"
  (paymentEmit)="savePayment($event)"
  (dispatchEdit)="onEditEvent($event)"
  (deleteBankDetailEvent)="deleteBankDetail($event)"
  (onBankDetailEmit)="createBankDetail($event)"
  (taskEmit)="taskEmit($event)"
  *ngIf="
    !(isLoadingScholarshipManagement$ | async) &&
    !(isLoadingCountry$ | async) &&
    !(isLoadingState$ | async) &&
    !(isLoadingLga$ | async) &&
    !(isLoadingCommunity$ | async) &&
    !(isLoadingScholarshipType$ | async) &&
    !(isLoadingScholarshipAwardDuration$ | async) &&
    !(isLoadingCourseOfStudy$ | async) &&
    !(isLoadingScholarshipCategory$ | async) &&
    !(isLoadingScholarshipSession$ | async) &&
    !(isLoadingGender$ | async) &&
    !(isLoadingScholarshipPayment$ | async) &&
    !(isLoadingBank$ | async) &&
    !(isLoadingCurrency$ | async) &&
    !(isLoadingBankDetail$ | async)
  "

  >

  </mrsoftapps-view-scholarship-management>
</ng-template>

<ng-template ngSwitchCase = "report">
  <!-- <pre>{{scholarshipPayment$ | async | json}}</pre> -->
  <mrsoftapps-scholarship-payment-report
   [countries]="country$ | async"
  [states]="state$ | async"
  [lgas]="lga$ | async"
  [scholarshipTypes]="scholarshipType$ | async"
  [scholarshipCategories]="scholarshipCategory$ | async"
  [scholarshipSessions]="scholarshipSession$ | async"
  [scholarshipAwardDurations]="scholarshipAwardDuration$ | async"
  [communities]="community$ | async"
  [courseOfStudies]="courseOfStudy$ | async"
  [genders]="gender$ | async"
  [scholarshipManagements]="scholarshipManagement$ | async"
  [scholarshipPayments]="scholarshipPayment$ | async"
  [banks]="bank$ | async"
  [scholarshipData]="scholarshipData"
  (changeEmit)="createEmit($event)"
  (getPaymentEmit)="getPayment($event)"
  (paymentEmit)="savePayment($event)"
  (dispatchEdit)="onEditEvent($event)"
  (taskEmit)="taskEmit($event)"
  *ngIf="
    !(isLoadingScholarshipManagement$ | async) &&
    !(isLoadingCountry$ | async) &&
    !(isLoadingState$ | async) &&
    !(isLoadingLga$ | async) &&
    !(isLoadingCommunity$ | async) &&
    !(isLoadingScholarshipType$ | async) &&
    !(isLoadingScholarshipAwardDuration$ | async) &&
    !(isLoadingCourseOfStudy$ | async) &&
    !(isLoadingScholarshipCategory$ | async) &&
    !(isLoadingScholarshipSession$ | async) &&
    !(isLoadingGender$ | async) &&
    !(isLoadingScholarshipPayment$ | async)
  "

  >

  </mrsoftapps-scholarship-payment-report>
</ng-template>

</div>


  <mrsoftapps-epims-reference-spinner
    *ngIf="
      (isLoadingScholarshipManagement$ | async) ||
      (isLoadingCountry$ | async) ||
      (isLoadingState$ | async) ||
      (isLoadingLga$ | async) ||
      (isLoadingCommunity$ | async) ||
      (isLoadingScholarshipType$ | async) ||
      (isLoadingScholarshipAwardDuration$ | async) ||
      (isLoadingCourseOfStudy$ | async) ||
      (isLoadingScholarshipCategory$ | async) ||
      (isLoadingScholarshipSession$ | async) ||
      (isLoadingScholarshipPayment$ | async) ||
      (isLoadingBank$ | async) ||
      (isLoadingBankDetail$ | async) ||
      (isLoadingCurrency$ | async) ||
      (isLoadingGender$ | async)
    "
  >
  </mrsoftapps-epims-reference-spinner>
  </main>
  </div>
</dashboardnav>
